/* KD add-on offer — PDP "add both" (Approach A, docs/addon_offer_spec.md).
   On a Full-Price Catalogue product page, +Add adds BOTH the page's selected
   variant AND the chosen add-on in one call, guaranteeing the 40% applies.
   Analytics: distinct Clarity events (kd_addon_pdp_*) so PDP vs cart-drawer
   attach can be told apart. All Clarity calls are guarded. */
(function () {
  if (window.__kdAddonOfferPdpInit) return;
  window.__kdAddonOfferPdpInit = true;

  function clarityTag(k, v) { try { if (window.clarity) window.clarity('set', k, v); } catch (e) {} }
  function clarityEvent(name) { try { if (window.clarity) window.clarity('event', name); } catch (e) {} }

  // --- Funnel denominator: fire once when the PDP strip is actually viewed ---
  var seenFired = false;
  function fireSeen() {
    if (seenFired) return;
    seenFired = true;
    clarityTag('kd_addon_pdp', 'strip_seen');
    clarityEvent('kd_addon_pdp_seen');
  }
  var strip = document.querySelector('.kd-addon-offer--pdp');
  if (!strip) return;
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { fireSeen(); io.unobserve(en.target); } });
    }, { threshold: 0.5 });
    io.observe(strip);
  } else {
    fireSeen();
  }

  // --- Resolve the PDP's currently-selected trigger variant id ---
  function triggerVariantId() {
    var formId = strip.getAttribute('data-product-form-id');
    var scope = (formId && document.getElementById(formId)) || document;
    var input = scope.querySelector('.product-variant-id') ||
                document.querySelector('product-form .product-variant-id');
    var val = input && input.value ? parseInt(input.value, 10) : 0;
    return val || 0;
  }

  // --- Click: add both ---
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.kd-addon-offer--pdp .kd-addon-offer__add');
    if (!btn) return;
    e.preventDefault();

    var card = btn.closest('.kd-addon-offer__item');
    var select = card ? card.querySelector('.kd-addon-offer__variant') : null;
    var addonId = select ? select.value : btn.dataset.variantId;
    if (!addonId) return;

    var triggerId = triggerVariantId();
    var errEl = card ? card.querySelector('.kd-addon-offer__error') : null;

    // No selectable trigger variant (size/option not chosen, or sold out) -> nudge, don't add.
    if (!triggerId) {
      if (errEl) {
        errEl.textContent = strip.getAttribute('data-select-msg') ||
          (window.kdAddonStrings && window.kdAddonStrings.selectVariant) ||
          'Please select size / option first';
        errEl.style.display = 'block';
      }
      var picker = document.querySelector('variant-radios, variant-selects, .product-form__input');
      if (picker && picker.scrollIntoView) picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      clarityEvent('kd_addon_pdp_needs_variant');
      return;
    }

    var handle = (card && card.dataset.handle) || '';
    clarityTag('kd_addon_pdp', 'add_clicked');
    if (handle) clarityTag('kd_addon_pdp_product', handle);
    clarityEvent('kd_addon_pdp_add_clicked');

    btn.disabled = true;
    var cartDrawer = document.querySelector('cart-drawer');

    var body = { items: [ { id: triggerId, quantity: 1 }, { id: parseInt(addonId, 10), quantity: 1 } ] };
    if (cartDrawer && cartDrawer.getSectionsToRender) {
      body.sections = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          clarityEvent('kd_addon_pdp_add_failed');
          if (errEl) { errEl.textContent = response.description || response.message || ''; errEl.style.display = 'block'; }
          btn.disabled = false;
          return;
        }
        clarityEvent('kd_addon_pdp_add_success');
        if (cartDrawer && cartDrawer.renderContents) {
          cartDrawer.renderContents(response);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        btn.disabled = false;
      })
      .catch(function () {
        clarityEvent('kd_addon_pdp_add_failed');
        btn.disabled = false;
      });
  });
})();
